// The phrase packs, the letter scaffolding and the little labels the phrasebook leans on.
export const PACK_TILES = [
  ["essentials", "The Absolute Essentials", "/tiles/packs/essentials.jpg"],
  ["survival", "Survival", "/tiles/packs/survival.jpg"],
  ["daily", "Daily Life", "/tiles/packs/daily.jpg"],
  ["airport", "Airport Travel", "/tiles/packs/airport.jpg"],
  ["doctor", "Doctor & Pharmacy", "/tiles/packs/doctor.jpg"],
  ["room", "Renting a Room", "/tiles/packs/room.jpg"],
  ["social", "Social · Making Friends", "/tiles/packs/social.jpg"],
  ["business", "Business Work", "/tiles/packs/business.jpg"],
];

export const LETTER_TEMPLATES = [
  {
    label: "Openings",
    lines: ["Dear Sir or Madam,", "Dear Mr / Ms [name],", "To whom it may concern,", "Hello,",
            "I hope this message finds you well."],
  },
  {
    label: "Getting to the point",
    lines: ["I am writing to ask about", "I would be grateful if you could",
            "Please could you confirm", "Apologies for the short notice, but"],
  },
  {
    label: "Closings",
    lines: ["Thank you for your time.", "Please let me know if you need anything else.",
            "Kind regards,", "Sincerely,", "Many thanks,"],
  },
];

export const pkey = (language, text) => `${language || "en"}|${(text || "").trim()}`;

export const STATE_STYLE = {
  mastered: { dot: "bg-forest", label: "Mastered" },
  learning: { dot: "bg-amber-400", label: "Learning" },
  new: { dot: "bg-white/20", label: "Not practised yet" },
};
